/** Navigatiedoelen binnen het Line Companion-paneel. */
export type HdLineCompanionTarget =
  | { readonly view: 'overview' }
  | { readonly view: 'gate'; readonly gate: number; readonly focusLine: number | null };

export interface HdLineCompanionPanelData {
  readonly target: HdLineCompanionTarget;
}

export const HD_LINE_COMPANION_PANEL_KEY = 'line-companion';
